// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "acquired" :
        return /* Acquired */3;
    case "completed" :
        return /* Completed */4;
    case "documents_verified" :
        return /* DocumentsVerified */0;
    case "ready" :
        return /* Ready */2;
    case "trainee" :
        return /* Trainee */1;
    default:
      return ErrorUtils$Catalyst.raiseError("OnboardingStatus.re", "Invalid onboarding status", status);
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

export {
  fromString ,
  t_decode ,
  
}
/* No side effect */
